module.exports = __webpack_public_path__ + "e507ee44550a4d4aa788da4f234d44eb.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Bold.eot
// module id = 705
// module chunks = 0